module.exports = __webpack_public_path__ + "static/media/tensilefront.0a3fc6a0.png";